import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes'

import { contentPageStore } from 'entities/excursions/content-page/model/content-page-store'

import { IExcursionDetails } from 'shared/api/excursions/list/model'
import { getCleanHTML } from 'shared/lib/getCleanHTML'
import { Paper } from 'shared/ui/paper'

import s from './guide-description.module.scss'

type Props = {
  excursionDetails: IExcursionDetails
}

export const GuideDescription = ({ excursionDetails }: Props) => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const getFullText = () => {
    contentPageStore.setContentState(
      t('excursions.description'),
      excursionDetails?.description,
    )

    navigate(RoutingPaths.excursion.contentPage.path())
  }

  if (!excursionDetails.description) {
    return
  }
  return (
    <Paper>
      <div className={s.excursionDescription}>
        <h4 className={s.descriptionTitle}>{t('excursions.description')}</h4>

        <div
          dangerouslySetInnerHTML={{
            __html: getCleanHTML(excursionDetails!.description),
          }}
          className={clsx(s.description, 'regular-14')}
        />

        <p
          className={s.readFull}
          onClick={getFullText}
        >
          {t('excursions.read_full')}
        </p>
      </div>
    </Paper>
  )
}
